import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class ImagenesRequestService {
  constructor(private http: HttpClient) {}

  /*
    Este método tiene la ruta principal de los servicios, la cual
    enrutará al servicio necesario, dependiendo de la petición del cliente.
  */
  public getRequest(request: string, params: any[]) {
    const URL = `http://190.85.249.87:8762/guardar-consultar-imagenes/${request}`;
    const HEADERS = new HttpHeaders({
      "Content-Type": "application/json"
    });

    return this.http.post(
      URL,
      {
        codigoBaseDatos: params[0],
        idEntidad: params[1],
        id: params[2]
      },
      { headers: HEADERS }
    );
  }

}
